import { render, staticRenderFns } from "./CompanySPServicesForm.vue?vue&type=template&id=008422f0&scoped=true"
import script from "./CompanySPServicesForm.vue?vue&type=script&lang=js"
export * from "./CompanySPServicesForm.vue?vue&type=script&lang=js"
import style0 from "./CompanySPServicesForm.vue?vue&type=style&index=0&id=008422f0&prod&lang=scss"
import style1 from "./CompanySPServicesForm.vue?vue&type=style&index=1&id=008422f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008422f0",
  null
  
)

export default component.exports